var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 171.1 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f1f2;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 84.02,
    y1: 63.69,
    x2: 84.02,
    y2: 124.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9c9cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a8aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 83.88,
    y1: 63.69,
    x2: 83.88,
    y2: 124.4,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "property_type-icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.72,73.38l17,0L84.1,16.5,82.34,18l-.67.58L71,28.24,37,59,20.24,73.12h17l0,60.2,31.8,0,2.14-.14.05-22.77v-3.6q0-10,0-20.08H96.78q0,11.5,0,23v1.88l.06,21.72,26.78.05,3.3,0,2.14,0,.1-.08,1.59,0v-60Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.92,54.13q-12.73-11.5-25.43-23c-.14-.13-.29-.24-.45-.37L55.56,56.35v0l-.36.35-.26.24-.32.29-7.2,6.52c-2.1,1.93-4.14,4-6.34,5.77a3.74,3.74,0,0,0-1.64,3.77,5.7,5.7,0,0,1,0,1.18q0,16,0,32.09,0,12.33,0,24.66l29.68,0h0q0-10.39,0-20.78,0-12.64,0-25.27c0-.18.2-.36.3-.54H98.59c.11.23.31.45.31.68q0,13.16,0,26.33l.05,19.6,24.66.05,4.75,0a.41.41,0,0,1,.25-.08q0-23.33,0-46.67c0-.59,0-1.19.05-1.78q0-5.92-.08-11.85Q119.24,62.52,109.92,54.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.06,19.33c-.38.32-.68.57-1,.83Q60,41,37,61.92C33.62,64.94,30.33,68,27,71v.07l.47,0L35,71l.6-.41,8.87-8L53,54.79l.39-.33.31-.31.27-.24q8.61-7.84,17.22-15.69c4.25-3.86,8.51-7.7,12.86-11.64l7.37,6.65,41.39,37.46c.11.1.23.18.35.27h7.5l.11-.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseImg);
export default __webpack_public_path__ + "static/media/houseImg.19a0e2ec29e142b00c62448409ff1b15.svg";
export { ForwardRef as ReactComponent };